import { Loading } from '@wfp/react';
import React, { useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';

import AdministrationDashboardTemplate from 'src/components/AdministrationDashboardTemplate';
import NoAccess from 'src/components/NoAccess';
import { requestAPI } from 'src/redux/data/actions';
import { GET_APP_CONFIGURATION } from 'src/redux/view/constants';

const AdministrationDashboard = props => {
  const dispatch = useDispatch();
  const appConfig = useSelector<RootStateOrAny, any | undefined>(
    state => state.viewData?.GET_APP_CONFIGURATION?.data,
  );
  const appConfigFetching = useSelector<RootStateOrAny, any | undefined>(
    state => state.viewData?.GET_APP_CONFIGURATION?.isFetching,
  );

  useEffect(() => {
    if (!appConfig) {
      dispatch(requestAPI(GET_APP_CONFIGURATION));
    }
  }, [dispatch, appConfig]);

  if (appConfigFetching || !appConfig) {
    return <Loading withOverlay={true} className="page-loader" />;
  }

  const hasPermissions = appConfig.userInfo?.hasDashboardPermission;
  if (!hasPermissions) {
    return <NoAccess variant="role" />;
  }

  return <AdministrationDashboardTemplate {...props} />;
};

export default AdministrationDashboard;
